import { NgModule } from '@angular/core';
import { DateRangeInputComponent } from './date-range-input/date-range-input.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ArrayInputComponent } from './array-input/array-input.component';
import { FactInputComponent } from './fact-input/fact-input.component';

import { CommonModule } from '@angular/common';
import { ImageUploadInputComponent } from './image-upload-input/image-upload-input.component';
import { ImageUploadModule } from 'angular2-image-upload';

@NgModule({
  declarations: [
    DateRangeInputComponent,
    ArrayInputComponent,
    FactInputComponent,
    ImageUploadInputComponent
  ],
  imports: [
    NgxDaterangepickerMd.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ImageUploadModule.forRoot()
  ],
  exports: [
    DateRangeInputComponent,
    ArrayInputComponent,
    FactInputComponent,
    ImageUploadInputComponent
  ],
})
export class SharedComponentsModule {}
